var map = {
	"./Burger Menu": 138,
	"./Burger Menu Close": 50,
	"./Burger Menu Close.svg": 50,
	"./Burger Menu.svg": 138,
	"./Cafod-Logo": 66,
	"./Cafod-Logo-strap-2019-Light-blue": 139,
	"./Cafod-Logo-strap-2019-Light-blue.png": 139,
	"./Cafod-Logo.jpg": 353,
	"./Cafod-Logo.png": 66,
	"./Cafod-Logo.svg": 354,
	"./Candle-Holder-Empty-Test1": 140,
	"./Candle-Holder-Empty-Test1.png": 140,
	"./Candle-Holder-Empty-Test2": 141,
	"./Candle-Holder-Empty-Test2.png": 141,
	"./Candle-Holder_3b": 142,
	"./Candle-Holder_3b.gif": 142,
	"./Candle-With-Tealight-no-wick": 143,
	"./Candle-With-Tealight-no-wick.png": 143,
	"./Church-Abstract": 144,
	"./Church-Abstract.jpg": 144,
	"./Cup-Empty-Zoomed-200": 145,
	"./Cup-Empty-Zoomed-200.png": 145,
	"./Cup-and-Candle-1920px-1": 146,
	"./Cup-and-Candle-1920px-1.png": 146,
	"./Cup-and-Candle-1920px-2": 147,
	"./Cup-and-Candle-1920px-2.png": 147,
	"./Cup-and-Candle-1920px-3": 148,
	"./Cup-and-Candle-1920px-3.png": 148,
	"./Cup-and-Candle-1920px-4": 149,
	"./Cup-and-Candle-1920px-4.png": 149,
	"./Cup-and-Candle-Zoomed-200": 150,
	"./Cup-and-Candle-Zoomed-200.png": 150,
	"./Flame-and-Glow": 151,
	"./Flame-and-Glow.png": 151,
	"./Just-Wick": 152,
	"./Just-Wick-unlit-zoomed": 153,
	"./Just-Wick-unlit-zoomed.png": 153,
	"./Just-Wick.png": 152,
	"./Metal-Bar-Rustic-1920px": 154,
	"./Metal-Bar-Rustic-1920px.png": 154,
	"./Metal-Bar-Scratched-2-1920px": 155,
	"./Metal-Bar-Scratched-2-1920px.png": 155,
	"./Metal-Bar-Simple-1920px": 156,
	"./Metal-Bar-Simple-1920px.png": 156,
	"./Tealight": 157,
	"./Tealight-no-wick": 158,
	"./Tealight-no-wick.png": 158,
	"./Tealight.png": 157,
	"./Tiled-Church-Wall-2": 159,
	"./Tiled-Church-Wall-2.jpg": 159,
	"./Tiled-Church-montage": 160,
	"./Tiled-Church-montage-defocus": 161,
	"./Tiled-Church-montage-defocus-opt": 162,
	"./Tiled-Church-montage-defocus-opt.jpg": 162,
	"./Tiled-Church-montage-defocus.png": 161,
	"./Tiled-Church-montage.png": 160,
	"./Tiled-Wall-2": 163,
	"./Tiled-Wall-2.png": 163,
	"./Tiled-Wall-2b": 164,
	"./Tiled-Wall-2b.png": 164,
	"./Wall-Background-Builder": 165,
	"./Wall-Background-Builder.png": 165,
	"./Wall-Tiled-1": 166,
	"./Wall-Tiled-1.png": 166,
	"./Warm-Abstract-1": 167,
	"./Warm-Abstract-1.png": 167,
	"./Warm-Abstract-2": 168,
	"./Warm-Abstract-2.png": 168,
	"./Warm-Abstract-3": 169,
	"./Warm-Abstract-3.png": 169,
	"./Warm-Abstract-4": 170,
	"./Warm-Abstract-4.png": 170,
	"./Warm-Abstract-5": 171,
	"./Warm-Abstract-5.png": 171,
	"./cafod-logo-2b-rgb": 103,
	"./cafod-logo-2b-rgb.svg": 103,
	"./candle": 172,
	"./candle.gif": 172,
	"./dt-church": 173,
	"./dt-church.png": 173,
	"./spritesheet": 104,
	"./spritesheet.json": 355,
	"./spritesheet.png": 104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 352;